import { GMetrixTableColumnProps } from 'components/GMetrixTable/components';
import { GMetrixButton } from 'components/GMetrixButton/GMetrixButton';
import { usePartnerLookup } from 'components/partner_lookup/context';
import { GMetrixTable } from 'components/GMetrixTable/GMetrixTable';
import { FormattedMessage, useIntl } from 'react-intl';
import { Partner } from 'apis/PartnerApi';
import { getFormattedDate } from 'utils';

export const PartnerLookupTable = props => {

    const { disabled, handlePageChange, handleSelect, handleSortChange, loading, partners, totalCount } = usePartnerLookup();
    const { formatMessage } = useIntl();

    const columnData: GMetrixTableColumnProps<Partner>[] = [
        {
            field: 'Name',
            title: formatMessage({ id: 'organization.7cb537a9', defaultMessage: 'Organization', description: 'New' })
        },
        {
            field: 'CustomerIDString',
            sortField: 'CustomerID',
            title: formatMessage({ id: 'customer_id.16ab92c3', defaultMessage: 'Customer ID', description: 'New' })
        },
        {
            cell: ({ dataItem }) => (
                <td>
                    {dataItem.Country?.Name ?? ''}
                </td>
            ),
            field: 'PartnerDetails',
            sortField: 'countryName',
            title: formatMessage({ id: 'country.05543f81', defaultMessage: 'Country', description: 'New' })
        },
        {
            cell: ({ dataItem }) => (
                <td>
                    {dataItem.State?.Name ?? ''}
                </td>
            ),
            field: 'StateID',
            sortField: 'StateName',
            title: formatMessage({ id: 'stateprovince.d2dfa3c8', defaultMessage: 'State/Province' })
        },
        {
            cell: ({ dataItem }) => (
                <td>
                    {getFormattedDate(dataItem.DateCreate)}
                </td>
            ),
            field: 'DateCreate',
            sortField: 'dateCreate',
            title: formatMessage({ id: 'created.8d9f8791', defaultMessage: 'Created' })
        },
        {
            cell: ({ dataItem }) => (
                <td>
                    <GMetrixButton
                        disabled={disabled}
                        onClick={() => handleSelect(dataItem)}
                        type="button"
                        variant="outline-primary"
                    >
                        {<FormattedMessage defaultMessage="Select" id="select.57e6e9c7" />}
                    </GMetrixButton>
                </td>
            ),
            sortable: false,
            title: '',
            width: 100
        }
    ];

    return (
        <GMetrixTable
            serverSidePagination
            columnData={columnData}
            defaultItemsPerPage={20}
            loading={loading}
            onServerPageChange={handlePageChange}
            onServerSortChange={handleSortChange}
            rowData={partners}
            serverTotalCount={totalCount}
            tableName={formatMessage({ id: 'partner_lookup.7135d3ea', defaultMessage: 'Partner Lookup' })}
        />
    );

};
